module.exports = __webpack_public_path__ + "static/media/supervisor-handover.36b77cc7.svg";